var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trash-base',{attrs:{"cols":_vm.cols}})
}
var staticRenderFns = []

export { render, staticRenderFns }